/* 仅处理有争议的必填项，其他情况直接在form上处理
* 出生日期和生日是特殊处理（商城必填，代理商生日和年龄二选一），该文件不处理
*/

// 商城额外必填项 ： 证件类型、证件号码、报告接收人、报告接收人电话、报告接收人地址
let mallOrderRequired = [
]
// 代理商额外必填项 ： 采集日期、运输日期、手机号、地区、客户地址、是否具备存储类合同
let agentOrderRequired = [
  'otherInfo.businessOriginArea' // 地区
]
let TYPE_SET_MAP = {
  'AGENT': agentOrderRequired,
  'MALL': mallOrderRequired
}
/**
 * tag：需要验证的字段，type：订单来源 MALL or AGENT
 * @param {*} tag
 * @param {*} type
 */
export function isRequired (tag, type = 'AGENT') {
  let requiredTag = TYPE_SET_MAP[type].includes(tag)
  if (requiredTag) {
    return 'required'
  }
  return ''
}
